import Vue from "vue";
import router from "@/router";
import { store } from "@/store/store";

export default {
  home() {
    Vue.nav.pushRouteTo("/home");
  },
  manageUsersGo() {
    Vue.nav.pushRouteTo("/admin/users");
  },
  out() {
    Vue.app.logout();
    Vue.nav.pushRouteTo("/login");
  },
  profileGo() {
    Vue.nav.pushRouteTo("/profile");
  },
  checkoutGo() {
    Vue.nav.pushRouteTo("/summary");
  },
  travelersGo() {
    Vue.nav.pushRouteTo("/my-travelers");
  },
  tripsGo() {
    Vue.nav.pushRouteTo("/planned-trips");
  },
  railGo() {
    Vue.nav.pushRouteTo("/search/rail");
  },
  groundTransportationGo() {
    Vue.nav.pushRouteTo("/search/ground-transportation");
  },
  manageTravelPolicies() {
    Vue.nav.pushRouteTo("/admin/travel-policy");
  },
  accountSettingsGo() {
    Vue.nav.pushRouteTo("/admin/account-settings");
  },
  tripLibraryGo() {
    Vue.nav.pushRouteTo("/admin/trip-library");
  },
  accountNotesGo() {
    Vue.nav.pushRouteTo("/admin/company-notes");
  },
  viewUserGo(id) {
    Vue.nav.pushRouteTo(`/users/${id}/profile`);
  },
  searchGo() {
    const booking = store.state.bookTravel.result;
    const isCarEmpty = Vue.helpers.isEmptyObject(booking.car);
    const isHotelEmpty = Vue.helpers.isEmptyObject(booking.hotel);
    const isFlightEmpty = Vue.helpers.isEmptyObject(booking.flight);

    if (isFlightEmpty || isHotelEmpty || isCarEmpty ) store.dispatch("bookTravel/setTripResult", {});

    Vue.nav.pushRouteTo("/search");
  },
  pushRouteTo(route) {
    router.push(route).catch(err => {
      if (err.name !== "NavigationDuplicated") console.error(err);
    });
  },
};
